import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { DashboardService } from '@pages/dashboard/dashboard.service';

export const suitabilityDetailsResolver: ResolveFn<any> = () => {
  const dashboardService = inject(DashboardService);
  return dashboardService.getSuitabilityDetails(
    Number(localStorage.getItem('productId'))
  );
};
